import Graphene, { PARTITION } from "@snapchat/graphene";
import { getWebConfig } from "@snapchat/graphene/lib/config/web";
import { BrowserNetworkHandler } from "@snapchat/graphene/lib/network/BrowserNetworkHandler";

import { BUILD_TYPE } from "../../shared/constants";

import { NetworkMetric } from "./NetworkMetric";

export class NetworkMetricsManager {
    private readonly initialized: boolean = false;

    constructor(enableGraphene: boolean) {
        if (enableGraphene) {
            Graphene.initialize({
                networkHandler: new BrowserNetworkHandler(
                    getWebConfig({
                        partitionName: PARTITION.MY_LENSES,
                        flavor: BUILD_TYPE,
                    }),
                ),
            });
            this.initialized = true;
        }
    }

    create(metricsName: string): NetworkMetric {
        return new NetworkMetric(metricsName, !this.initialized);
    }
}
